module.exports = __webpack_public_path__ + "img/r-134.e099c7ab.jpg";